exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-67271017]{-webkit-appearance:none;-moz-appearance:none;appearance:none}.order__input--date[data-v-67271017]{background-color:#fff}", ""]);

// exports
